var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99984 15.8332C12.0499 15.8332 15.3332 12.5499 15.3332 8.49984C15.3332 4.44975 12.0499 1.1665 7.99984 1.1665C3.94975 1.1665 0.666504 4.44975 0.666504 8.49984C0.666504 12.5499 3.94975 15.8332 7.99984 15.8332ZM11.2437 5.25608C11.363 5.37551 11.363 5.56915 11.2437 5.68858L8.4316 8.50546L11.2325 11.3111C11.3517 11.4305 11.3517 11.6242 11.2325 11.7436C11.1133 11.863 10.92 11.863 10.8007 11.7436L7.99983 8.93796L5.19893 11.7436C5.0797 11.863 4.88639 11.863 4.76716 11.7436C4.64793 11.6242 4.64793 11.4305 4.76716 11.3111L7.56806 8.50546L4.75593 5.68859C4.6367 5.56916 4.6367 5.37552 4.75593 5.25609C4.87516 5.13665 5.06847 5.13665 5.1877 5.25609L7.99983 8.07296L10.812 5.25608C10.9312 5.13665 11.1245 5.13665 11.2437 5.25608Z",
    fill: "#A9A9A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.f77339505e740b8a05b468e3ccecf028.svg";
export { ForwardRef as ReactComponent };